import React, { useState } from 'react';

export default function HomePage() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d65ij84c5bvcefa8qmmg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitMessage('Thank you! You have been successfully subscribed.');
        setEmail('');
      } else {
        setSubmitMessage('An error occurred. Please try again.');
      }
    } catch (error) {
      console.error('Submit error:', error);
      setSubmitMessage('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <main>
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <img
              alt="Hero Background"
              className="w-full h-[120%] object-cover object-center"
              src="https://public.readdy.ai/ai/img_res/425ffc951a06e5172f2fd38e2c18590f.jpg"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-slate-900/40 via-slate-900/20 to-slate-900/60 pointer-events-none"></div>

          <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-6 py-24 sm:py-32 text-center flex flex-col items-center justify-center">
            <div className="mb-3 sm:mb-6 md:mb-8">
              <span className="block text-[32px] sm:text-[56px] md:text-[72px] lg:text-[96px] font-semibold tracking-[0.1em] sm:tracking-[0.15em] md:tracking-[0.2em] text-white leading-none select-none drop-shadow-[0_0_30px_rgba(20,184,166,0.15)]">
                COMING SOON
              </span>
            </div>

            <div className="w-10 sm:w-20 md:w-24 h-px bg-gradient-to-r from-transparent via-teal-400/60 to-transparent mb-3 sm:mb-6 md:mb-8 mx-auto"></div>

            <div className="mb-6 sm:mb-10 md:mb-12">
              <span className="block text-[11px] sm:text-[13px] md:text-[16px] lg:text-[19px] tracking-[2px] sm:tracking-[4px] md:tracking-[6px] uppercase text-white/70 font-light">
                We're working on something great
              </span>
              <span className="block text-[9px] sm:text-[11px] md:text-[12px] lg:text-[13px] tracking-[1.5px] sm:tracking-[2.5px] md:tracking-[3px] uppercase text-white/40 font-light mt-1 sm:mt-1.5 md:mt-2">
                Available soon
              </span>
            </div>

            <h1 className="text-[22px] sm:text-[32px] md:text-[42px] lg:text-[52px] leading-[1.2] sm:leading-[1.15] font-light text-white mb-3 sm:mb-5 md:mb-6 max-w-3xl mx-auto px-2 sm:px-0">
              Innovation, Quality<br />
              <span className="italic font-extralight text-white/90">
                and Excellence United
              </span>
            </h1>

            <div className="max-w-2xl mx-auto px-4 sm:px-6 mt-4 sm:mt-6 md:mt-8">
              <p className="text-[11px] sm:text-[12px] md:text-[14px] text-white/55 font-light leading-[1.7] tracking-wide">
                Stay tuned and be one of the first to know when we go live.
                Our team is working passionately to create something extraordinary.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
